import './Checkbox.scss';
import { ReactNode } from 'react';

export interface CheckboxProps {
  /**
   *  This property sets the label for the checkbox
   */
  label?: string | ReactNode;
  /**
   * Set if the checkbox is checked or not
   */
  checked?: boolean;
  /**
   * Set if the input is disabled
   */
  disabled?: boolean;

  /**
   * Callback function called when checkbox state changes
   * @param checked - The new checked state of the checkbox
   */
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  alignItems?: 'start' | 'end' | 'center' | 'baseline' | 'stretch';
}

export const Checkbox = ({
  checked,
  label,
  disabled = false,
  alignItems = 'center',
  onChange,
  ...props
}: CheckboxProps) => {
  return (
    <div className='checkbox-wrap'>
      <label
        className={disabled ? 'checkbox checkbox--disabled' : 'checkbox'}
        style={alignItems ? { alignItems } : undefined}
      >
        <input
          className={
            disabled
              ? 'checkbox__input checkbox__input--disabled'
              : 'checkbox__input'
          }
          checked={checked}
          disabled={disabled}
          type='checkbox'
          onChange={onChange}
          {...props}
        />
        <span className='checkbox__label'>{label}</span>
      </label>
    </div>
  );
};

export default Checkbox;